import { render, staticRenderFns } from "./CourseByJoseph.vue?vue&type=template&id=217195e2"
import script from "./CourseByJoseph.vue?vue&type=script&lang=js"
export * from "./CourseByJoseph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports